import axios from "axios";

// Use current origin for API calls to avoid stale deployment URLs
export const BACKEND_URL = window.location.origin;
export const API = `${BACKEND_URL}/api`;

// Public links shared with clients (WhatsApp/email) must always point to the
// always-on production domain, never a sleeping preview host.
export const PUBLIC_APP_URL = process.env.REACT_APP_PUBLIC_APP_URL || window.location.origin;

// Global axios defaults for stability
axios.defaults.timeout = 30000; // 30s timeout prevents hanging requests
// AI / document-generation calls legitimately take longer than 30s (LLM round-trips, PDF rendering,
// email sending); without a longer timeout they surface as a bare "failed" toast on slow mobile networks.
const LONG_RUNNING = /\/(ai-split|ai-advisor|ai\/|agent\/|chatbot|quotations\/smart|quotations\/vision|receipts\/scan|price-estimate|translate|properties\/parse|pdf|send-email|portfolio-pdf|full-resync|voice|html)\b/;
axios.interceptors.request.use((config) => {
  if (LONG_RUNNING.test(config.url || "")) {
    config.timeout = Math.max(config.timeout || 0, 150000);
  }
  return config;
});
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Auto-logout on 401 (expired token)
    if (error.response?.status === 401 && window.location.pathname !== "/login") {
      const isAuthEndpoint = error.config?.url?.includes("/auth/");
      if (!isAuthEndpoint) {
        localStorage.removeItem("token");
        window.location.href = "/login?expired=1";
        return Promise.reject(error);
      }
    }
    // Network errors - don't flood console
    if (!error.response) {
      error.isNetworkError = true;
    }
    return Promise.reject(error);
  }
);
